

const GetHeaders = (jsonData: any) => {
    let currentH1Item = null;
    let currentH1Index = -1;

    const SECTIONS = []

    for (let i = 0; i < jsonData.length; i++) {
        const item = jsonData[i];
  
        if (item.type === "h1") {
          currentH1Item = {
            id: item.content.replace(/\s/g, "_").toLowerCase(),
            title: item.content,
            subSections: [],
          };
          currentH1Index = SECTIONS.push(currentH1Item) - 1;
        } else if (item.type === "h2" && currentH1Item) {
          if (SECTIONS[currentH1Index] !== currentH1Item) {
            // the current h2 should be a sub-section of the most recently added h1 item
            currentH1Item = SECTIONS[currentH1Index];
          }

          currentH1Item.subSections.push({
            id: `${currentH1Item.id}/${item.content.replace(/\s/g, "_").toLowerCase()}`,
            title: item.content,
          });
        }
      }

     return SECTIONS;
}

export default GetHeaders;
